import { Box, Step, StepLabel, Stepper, Typography } from "@material-ui/core";
import { Rule } from "pages/Rules/common/types";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import StepDetails from "./Details";
import steps from "./steps";
import StepTitle from "./StepTitle";

type Params = {
  rule: Rule;
};

export default function HorizontalStepper({ rule }: Params) {
  const { t } = useTranslation(["rules", "orgAndDomains"]);

  return (
    <Box>
      <Stepper alternativeLabel orientation="horizontal" activeStep={99}>
        {steps(rule, t).map(({ step, label }) => (
          <Step key={step} completed expanded>
            <StepLabel>
              <StepType>{label}</StepType>
              <Typography color="primary" variant="subtitle2">
                <StepTitle rule={rule} step={step} activeStep={99} />
              </Typography>
            </StepLabel>

            <StepDetailsContainer>
              <StepDetails rule={rule} step={step} />
            </StepDetailsContainer>
          </Step>
        ))}
      </Stepper>
      <LocaleAndTz rule={rule} />
    </Box>
  );
}

function LocaleAndTz({ rule }: { rule: Rule }) {
  const { t } = useTranslation("orgAndDomains");

  if (!rule.timeZone && !rule.locale) return null;

  return (
    <Box display="flex" justifyContent="end">
      <Typography variant="caption" component="div" color="textSecondary">
        <Box mr="1rem" mb="5px" display="flex" gridGap="2rem">
          {rule.locale && (
            <Box>
              <Box display="inline" fontWeight={500} mr=".5rem">
                {t("org.locale")}
              </Box>
              {t(`org.${rule.locale}`)}
            </Box>
          )}
          {rule.timeZone && (
            <Box>
              <Box display="inline" fontWeight={500} mr=".5rem">
                {t("org.timezone")}
              </Box>
              {rule.timeZone}
            </Box>
          )}
        </Box>
      </Typography>
    </Box>
  );
}

const StepType = styled("div")`
  font-weight: 500;
  text-transform: uppercase;
  font-size: 0.58rem;
  color: #6d6d6d;
`;

const StepDetailsContainer = styled.div`
  font-weight: 400;
  margin-top: 10px;
  text-align: center;
  & > ul {
    list-style-type: none;
    padding-inline-start: 0;
  }
`;
